/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendPoolContributionAsyncRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {SendPoolContributionAsyncResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const sendPoolContributionAsync = (request: SendPoolContributionAsyncRequest, options?: CashRequestOptions) => post<SendPoolContributionAsyncRequest, SendPoolContributionAsyncResponse>("/2.0/cash/send-pool-contribution-async", request, {...options, rejectOnError: true })